/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupListSource =
  (typeof ErrorGroupListSource)[keyof typeof ErrorGroupListSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupListSource = {
  backend: "backend",
  frontend: "frontend",
} as const;
